<div mat-dialog-title class="w-100">
    <div
        class="title d-flex align-items-center justify-content-space-between pop-up-header head"
    >
        <h4 class="mb-0 pop-up-text">
          
        </h4>
        <button
            class="close-button"
            (click)="close()"
        >
            <i class="flaticon-close"></i>
        </button>
    </div>
</div>
<div class="body">
    <div class="form-container">
        <div class="header">
            <h1>Agent Representation Request Form</h1>
            <h2>Request to Use the Services of a Representative of the University of Manchester</h2>
        </div>

        <div class="section">
            <div class="section-title">Student Section</div>
            
            <div class="form-row">
                <div class="form-label">First Name</div>
                <div class="form-value">{{firstName}}</div>
            </div>
            
            <div class="form-row">
                <div class="form-label">Last Name</div>
                <div class="form-value">{{lastName}}</div>
            </div>
            
            <div class="form-row">
                <div class="form-label">Date of Birth</div>
                <div class="form-value">{{dateOfBirth}}</div>
            </div>
            
            <div class="form-row">
                <div class="form-label">Course Applied</div>
                <div class="form-value">{{courseName}}</div>
            </div>
            
            <div class="form-row">
                <div class="form-label">Student Reference No.</div>
                <div class="form-value"></div>
            </div>
            
            <div class="form-row">
                <div class="form-label">Student Email id</div>
                <div class="form-value">{{email}}</div>
            </div>
            
            <div class="form-row">
                <div class="form-label">Student Contact Number</div>
                <div class="form-value">{{whatsAppNo}}</div>
            </div>
        </div>

        <div class="section">
            <div class="form-row">
                <div class="form-label">Your Proposed Agent:</div>
                <div class="form-value" style="font-weight: bold; color: #007acc;">FATEH EDUCATION</div>
            </div>
            <div class="agent-details">
                <div class="form-row">
                    <div class="form-label">Address/ Details of Your Proposed Agent:</div>
                    <div class="form-value"></div>
                </div>
                <div class="form-row">
                    <div class="form-label">Email:</div>
                    <div class="form-value"></div>
                </div>
                <div class="form-row">
                    <div class="form-label">Contact No.</div>
                    <div class="form-value"></div>
                </div>
            </div>
        </div>

        <div class="authorization">
            <p><strong>I would like to be represented in the admissions process by FATEH EDUCATION. I authorize them to act on my behalf during the entire admission process.</strong></p>
        </div>

        <div class="signature-section">
            <div class="signature-box">
                <div class="signature-line"></div>
                <div><strong>Signature</strong></div>
            </div>
            
            <div class="signature-box">
                <div class="signature-line">{{date}}</div>
                <div><strong>Date</strong></div>
            </div>
        </div>
        <div class="button-container">
            <button class="submit-button" (click)="sendForSignature()">Send for signature</button>
        </div>
    </div>
</div>

